import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { IStatefulCellAdapter } from "../IStatefulCellAdapter";
import { StringAdapter } from "../StringAdapter";
import { ColumnDefinition } from "../../model/ColumnDefinition";

// String types that are sortable as an Int32 in C++ module
export class ProductAdapter extends StringAdapter {
  constructor() {
    super();
  }

  getValue(order: any, product: CubiqTS.Product): string {
    switch (product) {
      case CubiqTS.Product.SPT:
        return "Spot";
      case CubiqTS.Product.FWD:
        return CubiqTS.RequestTrackingType.OUTRIGHT_RATE === order.requestTrackingType ||
          order.orderType === CubiqTS.OrderType.ALGO ||
          order.orderType === CubiqTS.OrderType.BENCHMARK
          ? "Fwd"
          : "Fwd (Spot)";
      case CubiqTS.Product.NDF:
        return CubiqTS.RequestTrackingType.OUTRIGHT_RATE === order.requestTrackingType
          ? "NDF"
          : "NDF (Spot)";
    }
    return "";
  }

  retrieveData(order: any, columnProperty: string): string {
    return this.getValue(order, order[columnProperty]);
  }

  retrieveFilter(order: any, columnProperty: string): string {
    return CubiqTS.Product[order[columnProperty]];
  }
}
